// extracted by mini-css-extract-plugin
module.exports = {"sponsoredBanner":"Gg","sponsoredTooltipWrapper":"Hg","sponsoredTooltip":"Ig","newCard":"Jg"};